import {Injectable} from '@angular/core';
import { Group } from '@edl-development/edl-common';
import {GroupApi} from '../api/group.api';
import { EDLGroupForm } from '../model/edl-groups/edl-group-form.component';
import { UpdateGroupsForUserModel } from '../groups/common/models/update-groups-for-user.model';
@Injectable()
export class GroupService {
    constructor(private groupApi: GroupApi) {

    }

    createGroup = (group: EDLGroupForm) => this.groupApi.createGroup(group);

    getGroupsByPortal = (portalId: number, offset?: number, limit?: number, orderBy?: string, ascending?: boolean, searchBy?: string, baseUrl?: string) =>
        this.groupApi.getGroupsByPortal(portalId, offset, limit, orderBy, ascending, searchBy, baseUrl);

    updateGroup = (group: EDLGroupForm) => this.groupApi.updateGroup(group);

    deleteGroup = (group: Group) => this.groupApi.deleteGroup(group);

    restoreGroup = (group: Group) => this.groupApi.restoreGroup(group);

    removeGroup = (group: Group) => this.groupApi.removeGroup(group);

    getGroupByGroupId = (groupId: string) => this.groupApi.getGroupByGroupId(groupId);

    getAllGroupsForPortal = () => this.groupApi.getAllGroupsForPortal();

    getGroupsAndPermissions = (userId: string) => this.groupApi.getGroupsAndPermissions(userId); 

    getUserGroupsByPortal = (offset: number, limit: number, searchBy: string, role: string, group: string, building: string) => 
        this.groupApi.getUserGroupsByPortal(offset, limit,  searchBy, role, group, building);

    saveGroupAssignment = (GroupID: string, UserId: any, checked: boolean): any =>
        this.groupApi.saveGroupAssignment(GroupID, UserId,  checked);

    updateGroupsForUser = (updates: UpdateGroupsForUserModel) =>
        this.groupApi.updateGroupsForUser(updates);

    uploadUsersForGroup = (fileList: FileList, group: EDLGroupForm): any => 
        this.groupApi.uploadUsersForGroup(fileList, group);

    // Volunteer Areas
    getVolunteerAreasByPortal = (portalId: number, offset?: number, limit?: number, orderBy?: string, ascending?: boolean) =>
        this.groupApi.getVolunteerAreasByPortal(portalId, offset, limit, orderBy, ascending);
}